export default __webpack_public_path__ + "static/media/Instagram.b4cf4e45.svg";